import React from 'react'
import { Link } from 'react-router-dom'

function Scoop() {
    return (
        <div className='font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/display" className="block py-1 pl-4 hover:underline mt-6">Display -</Link>
           <span className="block py-1 pl-4 mt-6">Scoop</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/newscoop.jpg" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">Scoop</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">Performance and visibility, your ice cream always at its best.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">Designed for modern Ice cream parlours, JORDAO’s SCOOP Ice Cream & Gelato showcase combines high-performance and superb product visibility. The advanced airflow design delivers consistent temperature throughout the showcase, ensuring that your ice cream keeps perfect for your Clients, they deserve your very best!Models for.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models for</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">
       <p className="text-xl lg:text-2xl opacity-90">Ice cream <span className='text-fuchsia-950'>-18… -15 °C</span><span className='text-gray-500'>(4L1)</span><span className='text-fuchsia-950'>-18… -10 °C</span>   <span className='text-gray-500'>(4G3)</span></p>
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-3"> R290</p>
         </div>
    
         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Maximum visibility, superb presentation for all your ice creams!</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Display case specially designed for artisanal and semi-industrial ice creams, prepared to display and conserve ice cream up to a height of 15 cm above the pan.</div>
    <div className='mt-6 text-xl font-thin text-gray-500'>Climate class 4, two temperature classes:L1 (-18... -15 °C) and G3 (-18... -10 °C).</div>
    <div className='mt-6 text-xl font-thin text-gray-500'>Models with capacity for 12, 18, 24 5 litre ice cream pans.</div>

</div>

                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/scoopcase.jpg" className="max-w-full h-auto object-contain" />
               </div>
             </div>
    
            {/* case 2 */}
             <div 
               className="flex flex-col  pb-16 mt-20 md:flex-row-reverse gap-6" >
               {/* ✅ Case Points */}
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/scoopcase1.gif" className="max-w-full h-auto object-contain" />
               </div>
    
               <div className="w-full md:w-1/2 px-4">
    <p className="text-2xl">Innovative technology for ice cream, always at its best</p>
    <div className='mt-6 text-xl font-thin text-gray-500'>Ventilated refrigeration system with double air channel and smooth ventilation that ensures a homogeneous temperature throughout the display, correctly preserving the characteristics and quality of your ice creams, even in demanding ambient conditions.</div>
</div>
             </div>
    
     {/* card & description */}
     <div className="flex flex-wrap gap-6 justify-center ">
  {[
    {
      img: "images/scopecard.jpg",
      text: "Ice cream counters with integrated condensing unit (plug-in).",
    },
    {
      img: "images/scopecard1.jpg",
      text: "Double-glazed end side panels and passive anti-condensation system for greater energy savings.",
    },
    {
      img: "images/scopecard2.jpg",
      text: "Front glass with gas struts for easy access and cleaning of the display unit.",
    },
    {
        img: "images/scopecard3.jpg",
        text: "Easy access to the condenser for cleaning and maintenance. Hygienic stainless-steel interiors and internal components easy to remove and clean.",
      },
  ].map((item, index) => (
    <div key={index} className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 flex flex-col items-center mb-6">
      <div>
        <img className="w-full max-w-[20rem]" src={item.img} alt="Card Image" />
      </div>
      <div className="mt-4 text-center text-xl font-thin text-gray-500 max-w-sm">
        {item.text}
      </div>
    </div>
  ))}
</div>
    
          
         </div>
     </div>
    
  
        </div>
      )
    }
export default Scoop